import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { inventoryAPI, dispatchAPI } from '../../utils/api';
import { FaBalanceScale, FaCheck, FaTimes, FaClipboardList } from 'react-icons/fa';
import LoadingSpinner from '../../components_shared/LoadingSpinner';
import './BlindEvaluationPage.css';

export default function BlindEvaluationPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [note, setNote] = useState(null);
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [formData, setFormData] = useState({
    memberName: '',
    passFail: true,
    remarks: ''
  });
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchNote();
  }, [id]);

  const fetchNote = async () => {
    try {
      setLoading(true);
      const res = await inventoryAPI.getDispatchNote(id);
      setNote(res.data);
    } catch (e) {
      setError('Failed to load dispatch note details.');
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setSubmitting(true);
      await inventoryAPI.addQcEvaluation(id, formData);
      navigate('/qc/dashboard');
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to submit evaluation.');
    } finally {
      setSubmitting(false);
    }
  };

  if (loading) return <LoadingSpinner />;
  if (error) return <div className="eduss-error-alert">{error}</div>;

  return (
    <div className="eduss-qc-container" style={{ padding: '20px' }}>
      <div className="eduss-dashboard-welcome">
        <h1><FaBalanceScale /> QC Blind Evaluation</h1>
        <p>Please perform a physical inspection and record your independent evaluation.</p>
      </div>

      <div className="eduss-grid-2-col" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '30px', marginTop: '30px' }}>
        <div className="eduss-card glassmorphism">
          <h3><FaClipboardList /> Shipment Details</h3>
          <div style={{ marginTop: '20px' }}>
            <div className="eduss-detail-item"><strong>Ref No:</strong> {note.referenceNo}</div>
            <div className="eduss-detail-item"><strong>Publisher:</strong> {note.publisher?.name}</div>
            <div className="eduss-detail-item"><strong>Quantity:</strong> {note.quantity}</div>
            <div className="eduss-detail-item"><strong>Status:</strong> <span className="eduss-badge blue">{note.status}</span></div>
          </div>
          <div style={{ marginTop: '20px' }}>
             <h4>Manifest:</h4>
             <ul>
               {note.items?.map(it => (
                 <li key={it.id}>{it.book?.name} - {it.dispatch_qty} units</li>
               ))}
             </ul>
          </div>
        </div>

        <div className="eduss-card glassmorphism">
          <h3>Evaluation Form</h3>
          <form onSubmit={handleSubmit} style={{ marginTop: '20px' }}>
            <div className="eduss-form-group">
              <label>Member Name</label>
              <input 
                type="text" 
                className="eduss-input" 
                value={formData.memberName}
                onChange={e => setFormData({...formData, memberName: e.target.value})}
                required
              />
            </div>
            
            <div className="eduss-form-group" style={{ marginTop: '20px' }}>
              <label>Final Verdict</label>
              <div style={{ display: 'flex', gap: '20px', marginTop: '10px' }}>
                <label className={`eduss-verdict-btn ${formData.passFail ? 'active pass' : ''}`}>
                  <input 
                    type="radio" 
                    name="verdict" 
                    checked={formData.passFail === true}
                    onChange={() => setFormData({...formData, passFail: true})}
                  />
                  <FaCheck /> PASS
                </label>
                <label className={`eduss-verdict-btn ${formData.passFail === false ? 'active fail' : ''}`}>
                  <input 
                    type="radio" 
                    name="verdict" 
                    checked={formData.passFail === false}
                    onChange={() => setFormData({...formData, passFail: false})}
                  />
                  <FaTimes /> FAIL
                </label>
              </div>
            </div>

            <div className="eduss-form-group" style={{ marginTop: '20px' }}>
              <label>Inspection Remarks</label>
              <textarea 
                className="eduss-input" 
                rows="4"
                value={formData.remarks}
                onChange={e => setFormData({...formData, remarks: e.target.value})}
                required
              ></textarea>
            </div>

            <button 
              type="submit" 
              className="eduss-btn primary large" 
              style={{ width: '100%', marginTop: '30px' }}
              disabled={submitting}
            >
              {submitting ? 'Submitting...' : 'Submit Evaluation'}
            </button>
          </form>
        </div>
      </div>

    </div>
  );
}
